import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import node, {
  type deploymentDetailsOverviewPageQuery,
} from '#gen/relay/deploymentDetailsOverviewPageQuery.graphql'

export const Route = createFileRoute(
  '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/',
)({
  staticData: { title: '[graph] - Deployment' },
  loader({ context, params }) {
    return context.preload<deploymentDetailsOverviewPageQuery>(node, params)
  },
  component: lazyRouteComponent(
    () =>
      import('#app/pages/branch/deployments/deployment-details-overview-page'),
    'DeploymentDetailsOverviewPage',
  ),
})
